import {useState} from "react";
import {resizeFile} from "../utils/FileResizer";

export const useFileReader = () => {
    const [imagesData, setImagesData] = useState([]);
    const convert = async(files) => {
        if (files) {
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const resizedFile = await resizeFile(file).then(res => {
                    return res
                })
                const reader = new FileReader();
                reader.onloadend = () => setImagesData(prev => ([...prev,{url:reader.result,raw:resizedFile}]));
                reader.readAsDataURL(resizedFile);
            }
        }
    };
    return [imagesData, setImagesData, convert]
}